/* Persistent fixed-position background atmosphere.
   Lifted from <div class="atmosphere"> in the original HTML. */
export default function Atmosphere() {
  return <div className="atmosphere" id="atmo" aria-hidden="true" />;
}
